export const TRANSLATION_ADMIN_LIST = "TRANSLATION_ADMIN_LIST";
export const TRANSLATION_MEMBER_LIST = "TRANSLATION_MEMBER_LIST";
export const TRANSLATION_GET_LANGAUGES = "TRANSLATION_GET_LANGAUGES";

